import Image from "./Image.vue";
import { pluginify } from "./../../util";
export default pluginify(Image);
export { Image };
